import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { User } from 'model/User';

import { encryptString } from '../../util/encryptUtil';

interface UserInfo {
  role: string | null;
  name: string | null;
  latestDt: string | null;
  isAuthenticated: boolean;
  updateUserInfo: (user: Partial<User>, isAuthenticated: boolean) => void,
  updateUserName: (name: string) => void;
  initUserInfo: () => void
}

export const userStore = create<UserInfo>()(
  persist(set => ({
    role: null,
    name: null,
    latestDt: null,
    isAuthenticated: false,
    updateUserInfo: (user: Partial<User>, isAuthenticated: boolean) => {
      set({
        role: encryptString(user.role ?? ''),
        name: user.name,
        latestDt: user.latestDt,
        isAuthenticated
      })
    },
    updateUserName: (name: string) => {
      set(state => ({
        ...state,
        name
      }))
    },
    initUserInfo: () => {
      set({
        role: null,
        name: null,
        latestDt: null,
        isAuthenticated: false,
      })
    }
  }), { name: 'user-storage' })
)